export default "__VITE_ASSET__b23b01cd__"